module.exports = __webpack_public_path__ + "img/daichao1.7765f672.png";